/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

export const BENEFICIARY_NUMBER_TYPE_CODE_RESAMI = 0
export const BENEFICIARY_NUMBER_TYPE_CODE_CPM = 20
export const BENEFICIARY_NUMBER_TYPE_CODE_IPP = 40
export const BENEFICIARY_NUMBER_TYPE_CODE_RA = 70
export const BENEFICIARY_NUMBER_TYPE_CODE_SYMIC = 80
export const BENEFICIARY_NUMBER_TYPE_CODE_PULSE = 90
export const BENEFICIARY_NUMBER_TYPE_CODE_PFID_FID = 100



// WEBPACK FOOTER //
// ./src/constants/BeneficiaryNumber.js